import React from 'react';
import { ErrorProvider } from './ErrorContext';
import { MfeOptionsProvider } from './MfeOptionsContext';
import { AppThemeProvider } from './ThemeContext';
import { OnboardingProvider } from './OnboardingContext';
import LaunchDarkly from 'src/services/LaunchDarkly';

type ProvidersProps = {
  children: React.ReactNode;
};

export const Providers = ({ children }: ProvidersProps): React.ReactElement => {
  return (
    <LaunchDarkly>
      <MfeOptionsProvider>
        <ErrorProvider>
          <OnboardingProvider>
            <AppThemeProvider>{children}</AppThemeProvider>
          </OnboardingProvider>
        </ErrorProvider>
      </MfeOptionsProvider>
    </LaunchDarkly>
  );
};
